import React, { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { InputField } from '../../../../ui/atoms/builder-2.0/InputField'
import { PayTermsAndConditions } from '../../../Auth/TermsAndConditions'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'
import { Spacer } from '../../../../ui/atoms'
import { DetailsRowItem } from '../../../Contractor/InvoicesTab/PayInvoice/DetailsRowItem'
import { BButton } from '../../../../ui/atoms/builder-2.0/Button'
import Loading from '../../../Loading'

const Footer = ({ onAgree, loading = false, disabled = false }) => {
  return (
    <>
      <PayTermsAndConditions />
      {/* <Divider
        style={{
          marginVertical: 20,
          height: 1,
          borderColor: '#F5F7F8',
          width: '100%',
        }}
      /> */}
      {/* <Spacer height={15} /> */}
      <View
        style={{
          backgroundColor: '#FFF',
          width: '100%',
          alignItems: 'center',
        }}
      >
        {/* <Spacer height={12} /> */}
        <View style={{ width: 335 }}>
          <BButton
            onPress={onAgree}
            buttonStyle={{ width: '100%', alignSelf: 'center' }}
            loading={loading}
            disabled={disabled}
          >
            {`Agree & Pay`}
          </BButton>
        </View>
        <Spacer height={40} />
      </View>
    </>
  )
}

interface PayWithPaymentMethodModalProps {
  invoiceTotal?: {
    fee: number
    totalAmount: string
    invoiceAmount: number
    lateFee: number
  }
  invoiceCompanyName: string
  loading: boolean
  disabled?: boolean
  onPay: () => void
  onClose: () => void
  paymentMethod: any
  handleChangePaymentMethod?: () => void
}

export const PayWithPaymentMethodModal: React.FC<PayWithPaymentMethodModalProps> =
  memo(
    ({
      loading,
      invoiceTotal,
      invoiceCompanyName,
      disabled = false,
      onPay,
      onClose,
      paymentMethod,
      handleChangePaymentMethod,
    }) => {
      const { t } = useTranslation(['errors', 'global'])

      const onChange = useCallback(() => {
        handleChangePaymentMethod?.()
      }, [handleChangePaymentMethod])

      console.log('here pm', paymentMethod)

      return (
        <BuilderBottomModal
          visible={true}
          title={t('global:payInvoice.pay-invoice')}
          onClose={onClose}
          height={600}
          footer={
            <Footer onAgree={onPay} disabled={loading} loading={loading} />
          }
          testID={'pay-with-payment-method-modal'}
        >
          {loading ? (
            <View
              style={{
                height: 350,
                justifyContent: 'center',
                alignItems: 'center',
              }}
              testID={'pay-with-payment-method-loading'}
            >
              <Loading />
            </View>
          ) : (
            <View
              style={{ width: '100%', marginTop: 16 }}
              testID={'pay-with-payment-method-invoice-details-container'}
            >
              <DetailsRowItem
                leftText={`${t('global:payInvoice.invoice-amount')}:`}
                rightText={invoiceTotal?.invoiceAmount ?? 0}
                money
              />
              <DetailsRowItem
                leftText={`${t('global:payInvoice.servicing_fee')}:`}
                rightText={invoiceTotal?.fee ?? 0}
                money
              />
              {!!invoiceTotal?.lateFee && (
                <DetailsRowItem
                  leftText={`${t('global:payInvoice.late-interest-charge')}:`}
                  rightText={invoiceTotal?.lateFee ?? 0}
                  money
                />
              )}
              <InputField
                testID={'input-invoice-amount'}
                label={t('global:payInvoice.total-amount')}
                editable={false}
                model={{
                  totalAmount: invoiceTotal?.totalAmount ?? '0',
                }}
                name={'totalAmount'}
                style={{ height: 56 }}
                inputOuterStyle={{ backgroundColor: '#F8F9F9' }}
              />
              <InputField
                testID={'input-pay-to-info'}
                label={t('global:payInvoice.To')}
                editable={false}
                model={{ name: invoiceCompanyName }}
                name="name"
                style={{ height: 56, color: 'black' }}
                inputOuterStyle={{ backgroundColor: '#F8F9F9' }}
              />

              <InputField
                label={t('global:payInvoice.payment-method')}
                model={{
                  paymentMethod: `${
                    (paymentMethod.accountName || paymentMethod.name).split(
                      '/',
                    )[0]
                  } ... ${paymentMethod.accountNumber?.slice(-3) || ''}`,
                }}
                name="paymentMethod"
                style={{ height: 56, marginBottom: 20 }}
                showDropdown
                onPress={onChange}
                editable={!!handleChangePaymentMethod}
              />
            </View>
          )}
        </BuilderBottomModal>
      )
    },
  )
